import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { BuyerActions } from './buyer.actions';
import { BillingRules, BuyerSettingsSave } from './buyer-state.model';

@Injectable({ providedIn: 'root' })
export class BuyerActionsFacade {
  private readonly _store = inject(Store);

  public load(buyerId: number): void {
    this._store.dispatch(BuyerActions.loadBuyerSettings({ buyerId }));
  }

  public save(cmp: number, update: BuyerSettingsSave): void {
    this._store.dispatch(BuyerActions.saveBuyerSettings({ cmp, update }));
  }

  public loadBillingRules(): void {
    this._store.dispatch(BuyerActions.loadBillingRules());
  }

  public createBillingRules(billingRules: BillingRules): void {
    this._store.dispatch(BuyerActions.createBillingRules({ billingRules }));
  }

  public updateBillingRules(billingRules: BillingRules): void {
    this._store.dispatch(BuyerActions.updateBillingRules({ billingRules }));
  }
}
